import { useNavigate } from 'react-router-dom';

import { signOut } from 'api/sessionApi';
import { useResetRecoilState } from 'recoil';
import { userInfoState } from 'recoil/user/atom';

import HeaderInfo from './HeaderInfo';

function Header() {
  // const userInfo = useRecoilValue(userInfoState);
  const resetUserInfo = useResetRecoilState(userInfoState);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    resetUserInfo();
    sessionStorage.clear();

    navigate('/sign-in');
  };

  return (
    <header id={'header-wrap'}>
      <HeaderInfo onClick={handleSignOut} />
    </header>
  );
}

export default Header;
